import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { DefaultFormData } from '../../local-types';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface FormBooleanProps extends DefaultFormData {
    value: number | boolean;
    switchOnLabel: string;
    switchTest?: (value: any) => boolean; // Made optional for flexibility
}

const FormSwitch = ({
    value,
    id,
    name,
    label,
    disabled,
    switchOnLabel,
    switchTest = (val) => (typeof val === 'number' ? val === 1 : Boolean(val)), // Default logic
    hint,
    handleChange,
}: FormBooleanProps): JSX.Element => {
    const classes = useStyles();

    const checked: boolean = switchTest(value);

    return (
        <FormControl className={classes.formControl} margin="dense">
            <div className={classes.divControl}>
                <div className={classes.formLabel}>{label}</div>
                <FormControlLabel
                    id={id}
                    name={name}
                    className={classes.formControlLabel}
                    control={
                        <Switch disabled={disabled} checked={checked} value={name ?? id} onChange={handleChange} />
                    }
                    label=""
                />
                <div className={classes.formLabel}>{switchOnLabel}</div>
            </div>
            {hint && <div className={classes.hint}>{hint}</div>}
        </FormControl>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formLabel: {
            fontSize: 12,
            color: theme.palette.primary.dark,
            fontWeight: 500,
        },
        formControl: {
            flexDirection: 'column',
        },
        formControlLabel: { marginLeft: 8 },
        divControl: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        hint: {
            fontSize: 12,
            color: theme.palette.text.secondary,
        },
    }),
);

export default FormSwitch;
